/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesHistoryType } from './WebApiModelsEnumerationTypesHistoryType';
import {
    WebApiModelsEnumerationTypesHistoryTypeFromJSON,
    WebApiModelsEnumerationTypesHistoryTypeFromJSONTyped,
    WebApiModelsEnumerationTypesHistoryTypeToJSON,
} from './WebApiModelsEnumerationTypesHistoryType';

/**
 * 
 * @export
 * @interface WebApiMemberDtoMemberCommunicationHistory
 */
export interface WebApiMemberDtoMemberCommunicationHistory {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    sent?: Date;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    sentFrom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    createdByName?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesHistoryType}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    type?: WebApiModelsEnumerationTypesHistoryType;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    sentContent?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoMemberCommunicationHistory
     */
    sentToAmount?: number | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoMemberCommunicationHistory interface.
 */
export function instanceOfWebApiMemberDtoMemberCommunicationHistory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoMemberCommunicationHistoryFromJSON(json: any): WebApiMemberDtoMemberCommunicationHistory {
    return WebApiMemberDtoMemberCommunicationHistoryFromJSONTyped(json, false);
}

export function WebApiMemberDtoMemberCommunicationHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoMemberCommunicationHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'sent': !exists(json, 'sent') ? undefined : (new Date(json['sent'])),
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'sentFrom': !exists(json, 'sentFrom') ? undefined : json['sentFrom'],
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
        'type': !exists(json, 'type') ? undefined : WebApiModelsEnumerationTypesHistoryTypeFromJSON(json['type']),
        'sentContent': !exists(json, 'sentContent') ? undefined : json['sentContent'],
        'sentToAmount': !exists(json, 'sentToAmount') ? undefined : json['sentToAmount'],
    };
}

export function WebApiMemberDtoMemberCommunicationHistoryToJSON(value?: WebApiMemberDtoMemberCommunicationHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sent': value.sent === undefined ? undefined : (value.sent.toISOString()),
        'subject': value.subject,
        'sentFrom': value.sentFrom,
        'createdByName': value.createdByName,
        'type': WebApiModelsEnumerationTypesHistoryTypeToJSON(value.type),
        'sentContent': value.sentContent,
        'sentToAmount': value.sentToAmount,
    };
}

